import React from 'react'

const message = props => {
  return (
    <div className="respond">
      <h4>{props.text}</h4>
    </div>
  )
}

export default message



// WEBPACK FOOTER //
// ./src/components/Message.js